<template>
  <v-card class="mt-2">
    <v-toolbar
      dense
      color="white"
      flat
    >
      <v-toolbar-title>
        <v-icon>mdi-credit-card</v-icon>
        חיובי אשראי
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        @click="addManual"
        text
        color="primary"
      >
        <v-icon class="me-2">mdi-plus</v-icon>
        הוספת שורה ידנית
      </v-btn>
      <v-btn
        @click="add"
        text
        color="primary"
      >
        <v-icon class="me-2">mdi-plus</v-icon>
        חיוב / זיכוי
      </v-btn>
    </v-toolbar>
    <v-divider />
    <v-card-text>
      <v-progress-linear
        indeterminate
        height="2"
        v-if="fetching"
      ></v-progress-linear>
      <template v-else-if="items.length">
        <v-data-table
          :headers="headers"
          :items="items"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-start">{{ format(item.created, 'DD/MM/YYYY') }}</td>
              <td class="text-start">{{ item.rawData ? item.rawData.PelecardTransactionId : '' }}</td>
              <td class="text-start">{{ item.rawData ? item.rawData.CreditCardNumber : '' }}</td>
              <td class="text-start">{{ item.rawData ? item.rawData.CardHebName : '' }}</td>
              <td class="text-start">{{ item.rawData ? item.rawData.CreditCardExpDate : '' }}</td>
              <td class="text-start">₪{{ ((item.totalWithVat + item.totalWithoutVat) / 100).toFixed(2) }}</td>
              <td class="text-start">
                <v-btn
                  v-if="!item.rawData"
                  icon
                  small
                  text
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon
                    icon
                    small
                  >mdi-pencil</v-icon>
                </v-btn>
              </td>
              <td class="text-start">
                <v-btn
                  v-if="!item.rawData"
                  icon
                  small
                  text
                  color="error"
                  @click="removeItem(item)"
                >
                  <v-icon
                    icon
                    small
                  >mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-alert
        :value="true"
        color="white"
        class="ma-0 grey--text"
        v-else
      >
        לא בוצעו תשלומים
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { format, isAfter } from "date-fns";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      removing: [],
      fetching: false,
      headers: [
        { text: "תאריך", align: "right", value: "created" },
        {
          text: "מזהה תשלום",
          align: "right",
          value: "transactionId",
          sortable: false
        },
        { text: "כרטיס", align: "right", value: "card", sortable: false },
        { text: "סוג כרטיס", align: "right", value: "card", sortable: false },
        { text: "תוקף כרטיס", align: "right", value: "card", sortable: false },
        { text: "סכום", align: "right", value: "total", sortable: false },
        { text: "עריכה", align: "right", sortable: false },
        { text: "מחיקה", align: "right", sortable: false }
      ]
    };
  },
  computed: {
    items() {
      return Object.values(this.$store.state.entities.payments)
        .filter(item => {
          return item.order && item.order === this.order._id;
        })
        .sort((a, b) => {
          return isAfter(a.created, b.created) ? -1 : 1;
        });
    }
  },
  props: ["order", "add", "addManual"],
  watch: {},
  mounted() {
    this.fetch();
  },
  methods: {
    format,
    fetch() {
      this.fetching = true;
      let query = {
        order: this.order._id
      };
      this.$store
        .dispatch("API_GET", {
          url: "/payments",
          entityType: "payments",
          schema: "paymentListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    addManualPayment() {},
    editItem(item) {
      let resource = this.$store.state.resources.payment;
      this.editEntity(item, resource);
    },
    removeItem(item) {
      let resource = this.$store.state.resources.payment;
      this.removeEntity(item, resource);
    }
  },
  components: {},
  mixins: [Mixins]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>